// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popover.monit_task_popover{min-width:auto}.monit_task_list_status{font-weight:600;padding:0 10px}.monit_task_list_status span{font-weight:500;font-size:12px;color:#999}.monit_task_list_status span.sus{color:#282729;margin-right:10px}.monit_task_list_status span.fail{color:#ff3973}.monit_task_list_status .progress{height:3px;background:#d4d4d4;border-radius:3px}.monit_task_list_status .progress .ing{height:100%;background:#ff3973;border-radius:3px}", ""]);
// Exports
module.exports = exports;
